/* global AP */
import { Option } from 'funfix-core';
import { Map } from 'immutable';
import { foldAppearance } from '../records/Flag';
export default {
  addFlagEventListeners: (onAction, onClose) => Option.of(AP.events).forEach(e => {
    e.on('flag.action', onAction);
    e.on('flag.close', onClose);
  }),
  createFlag: flag => {
    var _AP$flag, _flag$description$pri, _flag$description, _flag$description$sec, _flag$description2;
    return ((_AP$flag = AP.flag) === null || _AP$flag === void 0 ? void 0 : _AP$flag.create({
        actions: flag.actions.reduce((acc, a) => acc.set(a.id, a.displayText), Map()).toObject(),
        body: "".concat((_flag$description$pri = (_flag$description = flag.description) === null || _flag$description === void 0 ? void 0 : _flag$description.primary) !== null && _flag$description$pri !== void 0 ? _flag$description$pri : '').concat((_flag$description$sec = (_flag$description2 = flag.description) === null || _flag$description2 === void 0 ? void 0 : _flag$description2.secondary) !== null && _flag$description$sec !== void 0 ? _flag$description$sec : ''),
        close: flag.autoDismiss ? 'auto' : 'manual',
        title: flag.title,
        type: foldAppearance(flag.appearance, () => 'success', () => 'error', () => 'info', () => 'info')
      })
    );
  },
  removeFlagEventListeners: (onAction, onClose) => Option.of(AP.events).forEach(e => {
    e.off('flag.action', onAction);
    e.off('flag.close', onClose);
  })
};